// @ts-nocheck
import {
  CFG,
  DEFAULT_BINDS,
  ITEMS,
  ITEM_ORDER,
  KEYBINDS,
  KEY_TO_SLOT,
  REPORT_CATEGORIES,
  REPORT_CAT_ORDER,
  RESERVED_KEYS,
  ROBES,
  SLOT_ORDER,
  LOADOUT,
  SHOP_CATEGORY_ORDER,
  SPELLS,
  SPELL_AVAIL,
  SPELL_ORDER,
  SPELL_SCHOOLS,
  BOT_SKILLS,
  playerBotTag,
  normalizeBotSkill,
  START_LOADOUT,
  PVE_START_LOADOUT,
  PASSIVE_TREES,
  SKILL_POINTS,
  UPGRADE,
  eventKeyLabel,
  isLocalDev,
  isTeammate,
  itemCost,
  keyLabelForSlot,
  loadCreatePrefs,
  rebuildKeyToSlot,
  saveKeybinds,
  spellAvail,
  spellInfo,
  spellSfx,
  spellShopDesc,
  spellShopPurchasable,
  teamColor,
} from "../data";
import {
  TAU,
  bindTabPresenceUnload,
  clamp,
  len,
  lerp,
  rand,
  rgba,
  shade,
  shrinkState,
  tabPresenceId,
  track,
} from "../util";
import {
  PVE_GAUNTLET,
  SPRITE_BRIM,
  armTimedProg,
  assetURL,
  bossImageByOct,
  drawArmChargeAccent,
  drawArmRangeTelegraph,
  drawEntityGroundShadow,
  drawSpellSprite,
  drawStar,
  ensureBossAssets,
  ensureWarlockAssets,
  fireballSpriteFXEnabled,
  healPodFromWire,
  makeWizardSprite,
  octIndex,
  pveBossName,
  refreshSpellSpriteDevFields,
  spellCastPopLayer,
  spellCastPopPose,
  spellSpriteAnimFrame,
  spellSpriteDevVisible,
  spellSpriteDrawSz,
  spellSpritePhaseDrawSz,
  spellSpritePhaseLife,
  spellSpritePhaseOpt,
  spellSpritePhaseReady,
  spellSpritePhaseSpec,
  spellSpriteSpec,
  updateSpellSpriteDevPanelVisibility,
  warlockImage,
  warlockImageByOct,
  WARLOCK_CHARS,
} from "../sprites";
import {
  AUDIO_CREDITS,
  Sound,
} from "../audio";
import {
  spellIconInner,
  spellLabelHTML,
  synergyIconInner,
} from "../spell-icons";
import {
  EMPTY_OPTS,
  Particle,
  Pillar,
  Player,
  Sigil,
  compact,
  recalcItems,
} from "../entities";
import {
  Net,
  Tip,
  angLerp,
  angleDiff,
  escapeHtml,
  fmtWhen,
  modeLabel,
  ordinal,
  playerNameHTML,
  setupUiButtonSounds,
  showConfirm,
  spellLabel,
  spellTipHTML,
  tipAttr,
} from "../net-ui";
import {
  lobbyInviteURL,
  parseLobbyInviteCode,
} from "../lobby";
import { onSnapshotArrival, resetNetJitter } from "../net-jitter";

import { Game } from "./game-base";

Game.prototype.onPong = function () {
    const sent = this.net && this.net.lastPingSent;
    if (!sent) return;
    this.net.lastPingSent = 0;
    const rtt = performance.now() - sent;
    this.pingMs = this.pingMs ? this.pingMs * 0.6 + rtt * 0.4 : rtt; // light smoothing
    this.renderPing();
  }

Game.prototype.matchHudCorner = function () {
    const base = CFG.hudCornerBaseY;
    const line = CFG.hudCornerLineH;
    const hasGold = this.matchMode !== "allrandom" && this.matchMode !== "skilldraft";
    return {
      pingTop: base - 26,
      goldY: hasGold ? base : null,
      dmgY: hasGold ? base + line : base,
      toggleTop: base + (hasGold ? line * 2 : line) + 8,
    };
  }

Game.prototype.layoutPingMeter = function () {
    const el = document.getElementById("pingMeter");
    if (!el) return;
    const hud = this.matchHudCorner();
    el.style.right = "16px";
    el.style.left = "auto";
    el.style.top = `${hud.pingTop}px`;
  }

Game.prototype.renderPing = function () {
    const el = document.getElementById("pingMeter");
    if (!el) return;
    if (!this.isInArena()) {
      el.classList.add("hidden");
      return;
    }
    if (!this.pingMs) return;
    this.layoutPingMeter();
    const ms = Math.round(this.pingMs);
    el.textContent = `📶 ${ms} ms`;
    el.classList.remove("hidden", "good", "ok", "bad");
    el.classList.add(ms < 60 ? "good" : ms < 120 ? "ok" : "bad");
  }

Game.prototype.hidePing = function () {
    this.pingMs = 0;
    if (this.net) this.net.lastPingSent = 0;
    const el = document.getElementById("pingMeter");
    if (el) el.classList.add("hidden");
  }

Game.prototype.onServerMsg = function (msg) {
    if (msg.t !== "pong") this.onResynced();
    switch (msg.t) {
      case "pong": this.onPong(); break;
      case "catalog": this.onCatalog(msg); break;
      case "queuestatus": this.onQueueStatus(msg); break;
      case "queueinvite": this.onQueueInvite(msg); break;
      case "queueinviteend": this.onQueueInviteEnd(); break;
      case "readycheck": this.onReadyCheck(msg); break;
      case "readycheckend": this.onReadyCheckEnd(msg); break;
      case "mmcooldown": if (msg.secs > 0) this.beginMmQueueCooldown(msg.secs); break;
      case "achievement":
        this.showAchievementToast(msg);
        break;
      case "lobby": this.onLobby(msg); break;
      case "spectator": this.onSpectator(msg); break;
      case "specsync": this.onSpecSync(msg); break;
      case "round": this.onRound(msg); break;
      case "pillars": this.onPillars(msg); break;
      case "state": this.onState(msg); break;
      case "roundover": this.clearRoundSpectate(); this.scoreboardOpen = true; this.roundResultText = msg.text || ""; this.hide("banner"); this.state = "roundover"; this.syncMusic(); this.barTipKey = null; Tip.hide(); this.applyWins(msg.wins); this.applyPlacements(msg.placements); break;
      case "shop": this.onShop(msg); break;
      case "loadout": this.onLoadout(msg); break;
      case "reveal": this.onReveal(msg); break;
      case "draft": this.onDraft(msg); break;
      case "shopstatus": this.shopReadyCount = msg.ready; this.shopTotal = msg.total; this._drainPaused = !!msg.paused; this.updateReadyButton(); break;
      case "bossintrostatus": this.onBossIntroStatus(msg); break;
      case "matchover": this.onMatchOver(msg); break;
      case "sandboxhit": this.onSandboxHit(msg); break;
      case "sandboxsync": this.onSandboxSync(msg); break;
      case "sandboxbossbriefings": this.onSandboxBossBriefings(msg); break;
      case "notice": this.showToast(msg.msg || "", 8000); break;
      case "err": {
        this.creds = null;
        this.clearCreds();
        const fromInvite = this._joiningInvite;
        this._joiningInvite = false;
        const el = document.getElementById("reconnecting");
        if (el) el.classList.add("hidden");
        if (fromInvite) {
          if (this.net) { this.net.close(); this.net = null; }
          this.mode = "local";
          this.state = "menu";
          this.spectating = false;
          this.clearRoundSpectate();
          this.spectateWatchId = null;
          this.spectateWatchPending = null;
          this.hideSpectateHud();
          this.clearLobbyInviteURL();
          this.showHome();
          this.syncMusic();
          const m = (msg.msg || "").toLowerCase();
          const toast = (m.includes("not found") || m.includes("no longer")) ? "Lobby not found" : (msg.msg || "Could not join");
          this.showToast(toast);
        } else if (this._inMatchQueue) {
          this.leaveMatchQueue();
          this.showMatchmaker();
          const m = msg.msg || "Error";
          const wait = m.match(/^Wait (\d+) seconds before queuing again\./);
          if (wait) this.beginMmQueueCooldown(Number(wait[1]));
          this.showMmError(m);
        } else if (this.state === "lobby") {
          this.showToast(msg.msg || "Error");
        } else {
          this.showMenu();
          const m = (msg.msg || "").toLowerCase();
          if (m.includes("game has ended") || m.includes("seat has expired")) {
            this.showToast("Game has ended");
          } else {
            this.showToast(msg.msg || "Error");
          }
        }
        break;
      }
    }
    // A frontend update detected mid-round is deferred until a safe state; this
    // re-check applies it the moment a message transitions us out of active play
    // (e.g. into the shop or match-over).
    if (this._fePendingReload) this.maybeApplyFeUpdate();
  }

Game.prototype.ensureCatalog = function () {
    if (Object.keys(PASSIVE_TREES).length) return Promise.resolve();
    if (this._catalogFetch) return this._catalogFetch;
    this._catalogFetch = fetch("/catalog", { cache: "no-cache" })
      .then(r => { if (!r.ok) throw new Error("catalog"); return r.json(); })
      .then(msg => { this.onCatalog(msg); })
      .catch(() => {})
      .finally(() => { this._catalogFetch = null; });
    return this._catalogFetch;
  }

Game.prototype.onCatalog = function (msg) {
    if (msg.build) this.checkFeVersion(msg.build);
    if (msg.spells) {
      for (const id in msg.spells) {
        const color = (SPELLS[id] && SPELLS[id].color) || "#ffffff";
        SPELLS[id] = Object.assign({}, SPELLS[id], msg.spells[id], { id, color });
      }
    }
    if (msg.items) {
      for (const id in msg.items) ITEMS[id] = Object.assign({}, ITEMS[id], msg.items[id], { id });
    }
    if (Array.isArray(msg.spellOrder)) { SPELL_ORDER.length = 0; SPELL_ORDER.push(...msg.spellOrder); }
    for (const k of Object.keys(SPELL_AVAIL)) delete SPELL_AVAIL[k];
    Object.assign(SPELL_AVAIL, msg.spellAvailability || {});
    if (Array.isArray(msg.itemOrder)) { ITEM_ORDER.length = 0; ITEM_ORDER.push(...msg.itemOrder); }
    if (Array.isArray(msg.slotOrder)) { SLOT_ORDER.length = 0; SLOT_ORDER.push(...msg.slotOrder); }
    if (msg.maxEquippedSpells != null) LOADOUT.maxEquipped = msg.maxEquippedSpells;
    if (msg.startLoadout) {
      for (const k of Object.keys(START_LOADOUT)) delete START_LOADOUT[k];
      Object.assign(START_LOADOUT, msg.startLoadout);
    }
    if (msg.pveStartLoadout) {
      for (const k of Object.keys(PVE_START_LOADOUT)) delete PVE_START_LOADOUT[k];
      Object.assign(PVE_START_LOADOUT, msg.pveStartLoadout);
    }
    if (Array.isArray(msg.shopCategoryOrder)) { SHOP_CATEGORY_ORDER.length = 0; SHOP_CATEGORY_ORDER.push(...msg.shopCategoryOrder); }
    if (msg.upgrade) {
      UPGRADE.itemCostGrowth = msg.upgrade.itemCostGrowth;
      if (msg.upgrade.maxItems) UPGRADE.maxItems = msg.upgrade.maxItems;
    }
    if (msg.skillPoints) {
      const sp = msg.skillPoints;
      SKILL_POINTS.start = sp.start;
      SKILL_POINTS.startPassive = sp.startPassive ?? 0;
      SKILL_POINTS.startSynergy = sp.startSynergy ?? 0;
      SKILL_POINTS.sandboxStart = sp.sandboxStart;
      SKILL_POINTS.sandboxStartPassive = sp.sandboxStartPassive ?? 99;
      SKILL_POINTS.sandboxStartSynergy = sp.sandboxStartSynergy ?? 99;
      SKILL_POINTS.spPerRound = sp.spPerRound ?? 1;
      SKILL_POINTS.ppPerRound = sp.ppPerRound ?? 1;
      SKILL_POINTS.syEveryNRounds = sp.syEveryNRounds ?? 4;
      if (Array.isArray(sp.tiers)) SKILL_POINTS.tiers = sp.tiers;
      CFG.startSkillPoints = sp.start;
      CFG.startPassivePoints = sp.startPassive ?? 0;
      CFG.startSynergyPoints = sp.startSynergy ?? 0;
    }
    if (msg.passiveTrees) {
      for (const k of Object.keys(PASSIVE_TREES)) delete PASSIVE_TREES[k];
      Object.assign(PASSIVE_TREES, msg.passiveTrees);
    }
    this.renderKeyReferences();
    const sb = document.getElementById("spellbook");
    if (sb && !sb.classList.contains("hidden")) this.renderSpellbookCatalog("spellbookCatalog");
  }

Game.prototype.onSpectator = function (msg) {
    this.spectating = true;
    this.clearRoundSpectate();
    this.spectateWatchId = null;
    this.spectateWatchPending = null;
    this.myId = msg.you;
    this.isHost = false;
    this.lobby = null;
    const name = (document.getElementById("nameInput").value || "").trim();
    this.creds = { code: msg.code, token: msg.token, name, spec: true };
    this.saveCreds();
    this.matchRounds = msg.rounds || CFG.roundsPerMatch;
    this.matchMode = msg.mode || "normal";
    this.roundNumber = msg.round || 1;
    this.humanCount = 0;
    const el = document.getElementById("reconnecting");
    if (el) el.classList.add("hidden");
    this.hideAllPanels();
    if (msg.phase === "shop") {
      this.onSpectatorShop({ round: msg.round || this.roundNumber });
    } else {
      this.showSpectateHud();
    }
    this.syncMusic();
  }

Game.prototype.onSpecSync = function (msg) {
    if (!this.spectating) return;
    this.roundNumber = msg.round || this.roundNumber;
    if (msg.phase === "shop") {
      this.onSpectatorShop(msg);
      return;
    }
    this.hide("banner");
    this.showSpectateHud();
    this.state = msg.phase || this.state;
    this.syncMusic();
  }

Game.prototype.setShopDeadlineFromSecs = function (secs) {
    this.shopDeadline = secs > 0 ? performance.now() + secs * 1000 : 0;
  }

Game.prototype.onSpectatorShop = function (msg) {
    this.state = "shop";
    this.syncMusic();
    this.setShopDeadlineFromSecs(msg.secs);
    this.hideAllPanels();
    this.hideSpectateHud();
    this.barTipKey = null;
    Tip.hide();
    this.banner("Wait for players to select their spells", 0, false);
  }

Game.prototype.inSpectateView = function () { return this.spectating || this.roundSpectate; }

Game.prototype.setLobbySpectate = function (on) {
    if (!this.net || this.state !== "lobby") return;
    this.net.send({ t: "setspec", on: !!on });
  }

Game.prototype.clearRoundSpectate = function () {
    this.roundSpectate = false;
    if (this._roundSpectateTO) {
      clearTimeout(this._roundSpectateTO);
      this._roundSpectateTO = null;
    }
    if (!this.spectating) {
      this.hideSpectateHud();
      this.spectateWatchId = null;
      this.spectateWatchPending = null;
    }
  }

Game.prototype.enterRoundSpectate = function () {
    if (this.spectating || this.roundSpectate || this.matchMode === "sandbox") return;
    this.roundSpectate = true;
    this.scoreboardOpen = true;
    this.pickDefaultSpectateWatch();
    this.showSpectateHud();
  }

Game.prototype.tickRoundSpectate = function () {
    if (this.spectating || this.mode !== "remote" || this.matchMode === "sandbox") return;
    if (this.state !== "playing") {
      if (this._roundSpectateTO) {
        clearTimeout(this._roundSpectateTO);
        this._roundSpectateTO = null;
      }
      return;
    }
    const h = this.human();
    if (!h) return;
    const eliminated = !h.alive || h.falling;
    if (this.roundSpectate) return;
    if (eliminated) {
      if (!this._roundSpectateTO) {
        this._roundSpectateTO = setTimeout(() => {
          this._roundSpectateTO = null;
          const p = this.human();
          if (this.state === "playing" && p && (!p.alive || p.falling)) this.enterRoundSpectate();
        }, CFG.roundSpectateDelayMs);
      }
    } else if (this._roundSpectateTO) {
      clearTimeout(this._roundSpectateTO);
      this._roundSpectateTO = null;
    }
  }

Game.prototype.onLobby = function (msg) {
    const asSpec = !!msg.spec;
    this.spectating = asSpec;
    this.clearRoundSpectate();
    this.spectateWatchId = null;
    this.spectateWatchPending = null;
    this.hideSpectateHud();
    this.myId = msg.you;
    this.isHost = msg.owner != null ? !!msg.owner : (msg.host === msg.you);
    this.lobby = msg;
    this.refreshHumanCount(msg);
    const name = (document.getElementById("nameInput").value || "").trim();
    if (msg.token) {
      this.creds = { code: msg.code, token: msg.token, name };
      if (asSpec) this.creds.spec = true;
      else delete this.creds.spec;
      this.saveCreds();
    }
    // Matchmaker: stay on the search panel until the server auto-starts the match.
    if (this._matchmake && this._inMatchQueue) {
      this.dismissQueueInvite();
      const name = (document.getElementById("nameInput").value || "").trim();
      if (msg.token) {
        this.creds = { code: msg.code, token: msg.token, name };
        this.saveCreds();
      }
      this.myId = msg.you;
      this.isHost = msg.owner != null ? !!msg.owner : (msg.host === msg.you);
      this.lobby = msg;
      this.refreshHumanCount(msg);
      const have = (msg.members || []).filter(m => !m.bot && !m.sp).length;
      this.updateMatchQueueUI({ players: have, matching: have });
      return;
    }

    // Practice: we just created our private room. Configure it and start at once
    // (bots fill the empty seats server-side), skipping the lobby screen.
    if (this._practice && this.isHost) {
      const p = this._practice;
      this._practice = null;
      this.net.send({ t: "mode", mode: p.mode });
      this.net.send({ t: "bots", n: p.bots });
      this.net.send({ t: "botskill", skill: p.botSkill || "master" });
      this.net.send({ t: "rounds", n: p.rounds });
      this.net.send({ t: "startgold", n: p.startGold });
      this.net.send({ t: "start" });
      return;
    }
    if (this._sandbox && this.isHost) {
      const p = this._sandbox;
      this._sandbox = null;
      this.matchMode = "sandbox";
      this.net.send({ t: "mode", mode: "sandbox" });
      this.net.send({ t: "startgold", n: p.startGold });
      this.net.send({ t: "start" });
      this.syncLobbyInviteURL(msg.code);
      if (msg.token) {
        const name = (document.getElementById("nameInput").value || "").trim();
        this.creds = { code: msg.code, token: msg.token, name };
        this.saveCreds();
      }
      return;
    }
    if (this._applyCreatePrefs && this.isHost && this.net) {
      this._applyCreatePrefs = false;
      const p = loadCreatePrefs();
      this.net.send({ t: "mode", mode: p.mode });
      this.net.send({ t: "bots", n: p.bots });
      if (p.bots > 0) {
        this.lobbyBotSkill = p.botSkill;
        this.net.send({ t: "botskill", skill: p.botSkill });
      }
      this.net.send({ t: "rounds", n: p.rounds });
      this.net.send({ t: "startgold", n: p.startGold });
    }

    // Sandbox auto-starts: ignore lobby refreshes after mode is set (broadcastLobby).
    if (this.matchMode === "sandbox") {
      this.myId = msg.you;
      this.isHost = msg.owner != null ? !!msg.owner : (msg.host === msg.you);
      this.lobby = msg;
      if (msg.token) {
        const name = (document.getElementById("nameInput").value || "").trim();
        this.creds = { code: msg.code, token: msg.token, name };
        this.saveCreds();
      }
      return;
    }

    this.lobbyMode = msg.mode || "skilldraft";
    const midMatch = this.state === "shop" || this.state === "bossintro" ||
      this.state === "countdown" || this.state === "playing" || this.state === "roundover";
    const isPveLobby = this.lobbyMode === "pve";
    const isSandboxLobby = this.lobbyMode === "sandbox";

    const members = msg.members || [];
    const lobbyCodeEl = document.getElementById("lobbyCode");
    if (lobbyCodeEl) lobbyCodeEl.textContent = msg.code;
    const wrap = document.getElementById("lobbyMembers");
    if (!wrap) return;
    wrap.innerHTML = "";
    const humanCount = members.filter(x => !x.bot).length;
    const rosterCount = members.filter(x => !x.sp).length;
    const teamCap = Math.max(2, rosterCount);
    for (const m of members) {
      if (isPveLobby && m.bot) continue;
      const col = m.sp ? "#5a6a7a" : ROBES[m.color % ROBES.length].robe;
      let tag;
      if (m.id === msg.host) tag = '<span class="lobby-tag host">HOST</span>';
      else if (m.sp) tag = '<span class="lobby-tag spec">SPECTATOR</span>';
      else if (m.bot) tag = '<span class="lobby-tag bot">BOT</span>';
      else tag = '<span class="lobby-tag">PLAYER</span>';
      const you = (m.id === msg.you) ? " (you)" : "";
      const row = document.createElement("div");
      row.className = "lobby-row";
      row.innerHTML = `<span class="lobby-swatch" style="background:${col}"></span>` +
        `<span class="lobby-name">${playerNameHTML(m.name, "", 0, m.admin)}${you}</span>${tag}`;
      // team chip (players + bots). Host clicks to cycle teams and group allies up.
      if (!m.sp && this.lobbyMode !== "pve") {
        const chip = document.createElement("span");
        chip.className = "team-chip";
        chip.textContent = "Team " + m.team;
        chip.style.background = teamColor(m.team);
        if (this.isHost) {
          chip.classList.add("clickable");
          chip.title = "Click to change team — same team = allies (no friendly fire)";
          chip.onclick = () => { if (this.net) this.net.send({ t: "setteam", pid: m.id, team: (m.team % teamCap) + 1 }); Sound.ui(); };
        }
        row.appendChild(chip);
      }
      if (m.bot && !isPveLobby && !isSandboxLobby) {
        const skill = normalizeBotSkill(m.botSkill);
        const tier = BOT_SKILLS.find(t => t.id === skill);
        if (this.isHost) {
          const sel = document.createElement("select");
          sel.className = "bot-skill-select";
          sel.title = "Bot skill tier";
          for (const t of BOT_SKILLS) {
            const o = document.createElement("option");
            o.value = t.id;
            o.textContent = t.label;
            if (t.id === skill) o.selected = true;
            sel.appendChild(o);
          }
          sel.onchange = () => {
            if (this.net) this.net.send({ t: "setbotskill", pid: m.id, skill: sel.value });
            Sound.ui();
          };
          row.appendChild(sel);
        } else if (tier) {
          const lab = document.createElement("span");
          lab.className = "bot-skill-label";
          lab.textContent = tier.label;
          lab.title = tier.hint;
          row.appendChild(lab);
        }
      }
      if (m.id === msg.you) {
        const roleBtn = document.createElement("button");
        roleBtn.type = "button";
        roleBtn.className = "lobby-role-btn link-btn";
        if (m.sp) {
          roleBtn.textContent = "Play";
          roleBtn.onclick = () => { Sound.ui(); this.setLobbySpectate(false); };
        } else {
          roleBtn.textContent = "Spectate";
          roleBtn.onclick = () => { Sound.ui(); this.setLobbySpectate(true); };
        }
        row.appendChild(roleBtn);
      }
      wrap.appendChild(row);
    }
    this.matchRounds = msg.rounds || CFG.roundsPerMatch;
    const botsCountEl = document.getElementById("botsCount");
    if (botsCountEl) botsCountEl.textContent = msg.bots;
    const lobbyBotsRow = document.getElementById("lobbyBotsRow");
    if (lobbyBotsRow) lobbyBotsRow.style.display = (this.isHost && !isPveLobby && !isSandboxLobby) ? "flex" : "none";
    const roundsCountEl = document.getElementById("roundsCount");
    if (roundsCountEl) roundsCountEl.textContent = String(this.matchRounds);
    const lobbyRoundsRow = document.getElementById("lobbyRoundsRow");
    if (lobbyRoundsRow) lobbyRoundsRow.style.display = (this.isHost && !isPveLobby && !isSandboxLobby) ? "flex" : "none";
    if (msg.startGold != null) this.matchStartGold = msg.startGold;
    const lobbyModeRow = document.getElementById("lobbyModeRow");
    if (lobbyModeRow) lobbyModeRow.style.display = (this.isHost && !isSandboxLobby) ? "flex" : "none";
    const dungeonRow = document.getElementById("lobbyDungeonRow");
    if (dungeonRow) dungeonRow.style.display = isPveLobby ? "flex" : "none";
    this.updateModeUI();
    const humanPlayers = members.filter(m => !m.bot && !m.sp).length;
    const fighters = this.lobbyMode === "pve" || this.lobbyMode === "sandbox"
      ? humanPlayers
      : humanPlayers + (msg.bots || 0);
    const canStart = fighters >= (this.lobbyMode === "pve" || this.lobbyMode === "sandbox" ? 1 : 2);
    if (!this.isHost && this._lobbyStartDeadline) this.cancelLobbyStartCountdown(true);
    if (this.isHost && this.isLobbyStartCounting() && !canStart) this.cancelLobbyStartCountdown(true);
    this.syncLobbyStartButton(canStart);
    this.updateLobbyWaitText(canStart, asSpec);

    if (this.isHost && !this._matchmake && !midMatch) this.persistCreatePrefs();

    if (midMatch) return;

    this._joiningInvite = false;
    this.dismissQueueInvite();
    this.state = "lobby";
    this.syncMusic();
    const wasLobby = this.panelVisible("lobby");
    if (!wasLobby) this.hideAllPanels();
    this.show("lobby");
    this.syncLobbyInviteURL(msg.code);
  }

Game.prototype.updateModeUI = function () {
    const mode = this.lobbyMode || "skilldraft";
    const nb = document.getElementById("modeNormal");
    const ab = document.getElementById("modeAllRandom");
    const sb = document.getElementById("modeSkillDraft");
    const pb = document.getElementById("modePvE");
    if (nb && ab && pb) {
      nb.classList.toggle("active", mode === "normal");
      ab.classList.toggle("active", mode === "allrandom");
      if (sb) sb.classList.toggle("active", mode === "skilldraft");
      pb.classList.toggle("active", mode === "pve");
      nb.disabled = !this.isHost;
      ab.disabled = !this.isHost;
      if (sb) sb.disabled = !this.isHost;
      pb.disabled = !this.isHost;
    }
    const desc = document.getElementById("lobbyModeDesc");
    if (desc) {
      if (mode === "allrandom") {
        desc.textContent = "No shop. Each round the void deals you a random skill, two passives, and a synergy when one is available.";
      } else if (mode === "skilldraft") {
        desc.textContent = "No shop. After each round, pick a skill and two passives from random void offers (one reroll per pick).";
      } else if (mode === "pve") {
        desc.textContent = "Co-op boss gauntlet. Draft skills between encounters. Solo or up to 4 players.";
      } else if (mode === "sandbox") {
        desc.textContent = "Training arena. Share the room code so friends can join your sandbox.";
      } else if (mode === "normal") {
        desc.textContent = "Between rounds, visit the shop — spend skill, passive, and synergy points plus gold on spells, upgrades, and items.";
      } else {
        desc.textContent = "";
      }
    }
  }

Game.prototype.refreshHumanCount = function (msg) {
    if (msg && Array.isArray(msg.players)) {
      this.humanCount = msg.players.filter(p => !p.bot && !p.dummy).length;
      return;
    }
    if (msg && Array.isArray(msg.members)) {
      this.humanCount = msg.members.filter(m => !m.bot && !m.sp).length;
    }
  }

Game.prototype.onRound = function (msg) {
    this._drainPaused = false; // a new round means the server is no longer draining
    this.cancelLobbyStartCountdown(true);
    this.clearMatchmakerOnMatchStart();
    this.clearRoundSpectate();
    this.scoreboardOpen = false;
    this.refreshHumanCount(msg);
    this.maxRadiusServer = msg.maxRadius;
    this.maxRadius = msg.maxRadius;
    this.platformRadius = msg.maxRadius;
    this.roundNumber = msg.n;
    this.matchRounds = msg.rounds || CFG.roundsPerMatch;
    this.matchMode = msg.mode || "normal";
    this.layoutPingMeter();
    this.pveBossId = msg.boss || "";
    if (this.pveBossId) ensureBossAssets(this.pveBossId); // idle + adds only; cast on first castPose
    this.ixtholothRiftCollapsed = false;
    this.snaps = [];
    this._interpSnapRecv = 0;
    resetNetJitter(this);
    Sound.stopAllFirewallLoops();
    this.projectiles = []; this.mines = []; this.sigils = []; this.healpods = []; this.blizzards = []; this.firewalls = []; this.hellrips = []; this.stickymines = []; this.icewalls = []; this.voidglass = []; this.nullSphereErupts = []; this.bossBeams = []; this.particles = []; this.dmgPopups = [];
    this.shockwaves = []; this.beams = []; this.armPops = []; this.spellSpritePops = []; this.meteorCraters = []; this.floorBurns = []; this.bloodStains = []; this.plagueStains = []; this.frostStains = []; this.meteorNukeClouds = []; this.meteorNukeSwamps = []; this.meteorNukeFuses = [];
    this.chargingSlot = null;
    this.pred = { init: false, moveTarget: null, hasMove: false, knockT: 0, x: 0, y: 0, vx: 0, vy: 0, alive: true, falling: false, stun: false };
    if (this.simReady) wsimReset();
    this.resetWalkBobTrackers();

    this.players = [];
    this.playerById = {};
    this.decoys = [];
    for (const pw of msg.players) {
      const p = new Player(pw.color, pw.id === msg.you);
      p.id = pw.id;
      p.name = pw.name;
      p.colorName = pw.name;
      p.title = pw.title || "";
      p.titlePos = pw.titlePos || 0;
      p.admin = !!pw.admin;
      p.dummy = !!pw.dm;
      p.dumbEnemy = !!pw.de;
      p.isBot = !!pw.bot;
      p.botSkill = pw.bot ? normalizeBotSkill(pw.botSkill) : "";
      p.boss = pw.bs || "";
      if (p.dummy) { p.robe = "#6b7280"; p.trim = "#d1d5db"; }
      p.wins = pw.wins || 0;
      p.team = pw.team || 0;
      p.alive = true;
      this.players.push(p);
      this.playerById[pw.id] = p;
    }
    // Preload idle + cast billboards only for the warlock themes actually in this room.
    ensureWarlockAssets([...new Set(
      this.players.filter(p => !p.boss).map(p => WARLOCK_CHARS[p.index % WARLOCK_CHARS.length])
    )]);
    this.pillars = msg.pillars.map(q => new Pillar(q.x, q.y, q.r));
    this.pillarsDirty = true; // re-push to the prediction sim once

    const h = this.human();
    if (h) {
      if (msg.loadout) h.loadout = msg.loadout;
      if (msg.committed) h.committed = msg.committed;
      if (msg.passives) h.passives = msg.passives;
      if (msg.items) { h.items = msg.items; recalcItems(h); }
    }
    this.camX = h ? h.x : 0;
    this.camY = h ? h.y : 0;

    this.hideAllPanels();
    if (this.matchMode === "sandbox") {
      this.closeSandboxShop();
      this.closeSandboxDraft();
      this.show("sandboxHud");
      this.sandboxActivity = null;
      this.sandboxLastHitAt = 0;
      this.renderSandboxActivity(null);
      this.updateSpellSpriteDevPanel();
    }
    this._combatMusicTrack = Sound.combatMusicPath(msg.cm);
    if (this.matchMode === "pve" && msg.bossIntro && document.getElementById("bossIntro")) {
      this.state = "bossintro";
      this.bossIntroPreview = false;
      this.bossIntroReadied = false;
      this.bossIntroReadyIds = [];
      this.bossIntroTotal = Math.max(1, this.humanCount || 0);
      this.renderBossIntro(msg.bossIntro);
      this.show("bossIntro");
      this.hide("banner");
    } else if (this.matchMode === "sandbox") {
      this.state = "playing";
      this.hide("banner");
    } else {
      this.state = "countdown";
      if (this.matchMode === "pve" && this.pveBossId) {
        this.banner(`BOSS ${this.roundNumber}/${this.matchRounds} — ${pveBossName(this.pveBossId).toUpperCase()}`);
      }
    }
    if (this.spectating) {
      this.hide("banner");
      this.showSpectateHud();
      this.pickDefaultSpectateWatch();
      const t = this.spectateTarget();
      if (t) { this.camX = t.x; this.camY = t.y; }
    }
    this.syncMusic();
  }

Game.prototype.onPillars = function (msg) {
    if (!msg.pillars) return;
    this.pillars = msg.pillars.map(q => new Pillar(q.x, q.y, q.r));
    this.pillarsDirty = true;
  }

Game.prototype.spectateWatchable = function (p) {
    return p && !p.dummy && p.alive && !p.falling;
  }

Game.prototype.spectateCycleList = function () {
    return this.players.filter(p => this.spectateWatchable(p)).sort((a, b) => a.id - b.id);
  }

Game.prototype.spectateTarget = function () {
    if (this.spectateWatchId == null) return null;
    return this.playerById[this.spectateWatchId] || null;
  }

Game.prototype.applyWatchKit = function (w) {
    if (!w || w.id == null) return;
    // State snapshots are queued ahead of the watch message — ignore stale kits.
    if (this.spectateWatchPending != null && w.id !== this.spectateWatchPending) return;
    const p = this.playerById[w.id];
    if (!this.spectateWatchable(p)) {
      this.ensureAliveSpectateTarget();
      return;
    }
    if (this.spectateWatchPending === w.id) this.spectateWatchPending = null;
    this.spectateWatchId = w.id;
    if (!p) return;
    if (w.gold != null) p.gold = w.gold;
    if (w.sp != null) p.skillPoints = w.sp;
    if (w.pp != null) p.passivePoints = w.pp;
    if (w.sy != null) p.synergyPoints = w.sy;
    if (w.cd) p.cd = w.cd;
    if (w.loadout) p.loadout = w.loadout;
    if (w.committed) p.committed = w.committed;
    if (w.items) { p.items = w.items; recalcItems(p); }
    if (w.aim != null) p.aim = w.aim;
    p.dmgDealt = w.dmg || 0;
    p.kills = w.kills || 0;
    this._watchEffects = (w.fx || []).map(e => ({
      id: e.id,
      buff: !!e.bf,
      spell: e.sp || "",
      rem: e.rem,
      val: e.v || 0,
      at: performance.now(),
    }));
    this.updateSpectateHud();
  }

Game.prototype.pickDefaultSpectateWatch = function () {
    const list = this.spectateCycleList();
    if (!list.length) return;
    this.setSpectateWatch(list[0].id);
  }

Game.prototype.ensureAliveSpectateTarget = function () {
    if (!this.inSpectateView()) return;
    const t = this.spectateTarget();
    if (t && this.spectateWatchable(t)) return;
    const list = this.spectateCycleList();
    if (!list.length) {
      this.spectateWatchId = null;
      this.spectateWatchPending = null;
      this.updateSpectateHud();
      return;
    }
    const cur = list.find(p => p.id === this.spectateWatchId);
    if (cur && this.spectateWatchable(cur)) return;
    this.setSpectateWatch(list[0].id);
  }

Game.prototype.setSpectateWatch = function (id) {
    const p = this.playerById[id];
    if (!this.spectateWatchable(p)) return;
    if (this.spectateWatchId === id && this.spectateWatchPending == null) return;
    this.spectateWatchId = id;
    this.spectateWatchPending = id;
    if (this.net) this.net.send({ t: "watch", id });
    this.updateSpectateHud();
  }

Game.prototype.cycleSpectate = function (delta) {
    const list = this.spectateCycleList();
    if (!list.length) return;
    let idx = list.findIndex(p => p.id === this.spectateWatchId);
    if (idx < 0) idx = 0;
    idx = (idx + delta + list.length) % list.length;
    this.setSpectateWatch(list[idx].id);
  }

Game.prototype.showSpectateHud = function () {
    const el = document.getElementById("spectateHud");
    if (el) el.classList.remove("hidden");
    this.updateSpectateHud();
  }

Game.prototype.hideSpectateHud = function () {
    const el = document.getElementById("spectateHud");
    if (el) el.classList.add("hidden");
    this._watchEffects = [];
  }

Game.prototype.spectateHudTop = function () {
    const hasViewing = this.matchMode !== "sandbox"
      && (this.state === "playing" || this.state === "countdown" || this.state === "roundover");
    // canvas: title @14px, "Viewing …" @34px (base line ~14px tall)
    return hasViewing ? 52 : 36;
  }

Game.prototype.updateSpectateHud = function () {
    const el = document.getElementById("spectateHud");
    const label = document.getElementById("specWatchLabel");
    if (label) {
      const p = this.spectateTarget();
      label.textContent = p ? ((p.colorName || p.name || "Player") + playerBotTag(p)) : "—";
    }
    if (el && !el.classList.contains("hidden")) {
      el.style.top = `${this.spectateHudTop()}px`;
      el.style.bottom = "auto";
    }
  }

Game.prototype.renderBossIntroPortrait = function (intro) {
    const img = document.getElementById("bossIntroImg");
    const canvas = document.getElementById("bossIntroCanvas");
    const art = img && img.parentElement;
    if (!img || !canvas || !art) return;

    const canvasBosses = new Set(["aurelion", "ixtholoth"]);
    const portraitBosses = new Set(["angel", "titan", "groshkar", "kael", "vorathal", "sisters"]);
    const id = intro.id || "";

    img.className = "boss-intro-portrait hidden";
    canvas.className = "boss-intro-portrait hidden";
    art.className = "boss-intro-art";
    img.removeAttribute("src");

    if (canvasBosses.has(id)) {
      canvas.classList.remove("hidden");
      art.classList.add("boss-intro-art--canvas");
      this.drawBossIntroCanvas();
      return;
    }

    if (portraitBosses.has(id)) {
      img.classList.remove("hidden");
      if (id === "vorathal") art.classList.add("boss-intro-art--tall");
      else if (id === "angel" || id === "titan") art.classList.add("boss-intro-art--compact");
      img.src = id === "sisters"
        ? "sprites/bosses/sisters/portrait/portrait.png"
        : `sprites/bosses/${id}/portrait/portrait.png`;
    }
  }

Game.prototype.drawBossIntroCanvas = function () {
    const canvas = document.getElementById("bossIntroCanvas");
    if (!canvas || canvas.classList.contains("hidden") || !this.bossIntro) return;
    const id = this.bossIntro.id;
    if (id !== "aurelion" && id !== "ixtholoth") return;
    const c = canvas.getContext("2d");
    if (!c) return;
    c.clearRect(0, 0, canvas.width, canvas.height);
    c.save();
    c.translate(canvas.width / 2, canvas.height / 2);
    const spin = this.nowS * 0.4;
    const stub = { radius: id === "ixtholoth" ? 22 : 28, boss: id, facing: Math.PI / 4, beamSpin: spin, channelSpell: "", channelProg: 0 };
    if (id === "aurelion") this.drawAurelionRotating(c, stub, spin);
    else this.drawIxtholothEye(c, stub, spin);
    c.restore();
  }

Game.prototype.renderBossIntro = function (intro) {
    if (!intro) return;
    const panel = document.getElementById("bossIntro");
    if (!panel) return;
    this.bossIntro = intro;
    const set = (id, text) => { const el = document.getElementById(id); if (el) el.textContent = text; };
    set("bossIntroEyebrow", `Boss ${intro.round || 1} / ${intro.rounds || 1}`);
    set("bossIntroName", intro.name || pveBossName(intro.id));
    set("bossIntroDesc", intro.desc || "");
    set("bossIntroHP", (intro.hp || 0).toLocaleString());
    this.renderBossIntroPortrait(intro);

    const essentialsEl = document.getElementById("bossIntroEssentials");
    if (essentialsEl) {
      essentialsEl.innerHTML = "";
      const lines = intro.essentials || intro.tips || [];
      lines.forEach(line => {
        const li = document.createElement("li");
        li.textContent = typeof line === "string" ? line : (line.detail || line.label || "");
        essentialsEl.appendChild(li);
      });
    }

    const abWrap = document.getElementById("bossIntroAbilities");
    if (abWrap) {
      abWrap.innerHTML = "";
      (intro.abilities || []).forEach(ab => {
        const school = SPELL_SCHOOLS[ab.school];
        const color = (school && school.color) || "#8a86a6";
        const stats = [];
        if (ab.cd) stats.push({ text: `CD ${ab.cd}`, threat: false });
        if (ab.threat) stats.push({ text: ab.threat, threat: true });
        const statsHtml = stats.length
          ? `<div class="boss-intro-ability-stats">${stats.map(s =>
              `<span class="abi-stat${s.threat ? " abi-stat--threat" : ""}">${escapeHtml(s.text)}</span>`
            ).join("")}</div>`
          : "";
        const card = document.createElement("div");
        card.className = "boss-intro-ability";
        card.innerHTML =
          `<span class="abi-icon" style="background:${color}22;border:1px solid ${color}55">${escapeHtml(ab.fallbackIcon || "✦")}</span>` +
          `<div><div class="abi-name">${escapeHtml(ab.name || ab.id)}</div>` +
          (ab.when ? `<div class="abi-when">${escapeHtml(ab.when)}</div>` : "") +
          statsHtml +
          (ab.desc ? `<div class="abi-desc">${escapeHtml(ab.desc)}</div>` : "") +
          `</div>`;
        abWrap.appendChild(card);
      });
    }

    const phases = document.getElementById("bossIntroPhases");
    if (phases) {
      phases.innerHTML = "";
      (intro.phases || []).forEach(ph => {
        const li = document.createElement("li");
        li.innerHTML = `<b>${escapeHtml(ph.at)}</b>${escapeHtml((ph.notes || []).join(" · "))}`;
        phases.appendChild(li);
      });
    }
    this.updateBossIntroReadyButton();
  }

Game.prototype.onSandboxBossBriefings = function (msg) {
    if (!msg || !msg.intros || !msg.intros.length) return;
    this.showSandboxBossBriefings(msg.intros);
  }

Game.prototype.onBossIntroStatus = function (msg) {
    this.bossIntroReadyIds = msg.ready || [];
    this.bossIntroTotal = msg.total || Math.max(1, this.humanCount || 0);
    this.updateBossIntroReadyButton();
  }

Game.prototype.updateBossIntroReadyButton = function () {
    const btn = document.getElementById("bossIntroReadyBtn");
    const hint = document.getElementById("bossIntroWait");
    if (this.bossIntroPreview) {
      if (btn) {
        btn.textContent = "CLOSE";
        btn.classList.remove("ready-on");
        btn.disabled = false;
      }
      if (hint) hint.textContent = "Sandbox preview — page through all bosses";
      this.syncBossIntroPager();
      return;
    }
    const pager = document.getElementById("bossIntroPager");
    if (pager) pager.classList.add("hidden");
    const remote = this.mode === "remote";
    const ready = (this.bossIntroReadyIds || []).length;
    const total = this.bossIntroTotal || Math.max(1, this.humanCount || 0);
    let label = "READY — BEGIN FIGHT";
    let wait = "";
    if (remote && total > 1) {
      wait = `${ready}/${total} ready`;
      if (this.bossIntroReadied) label = "WAITING FOR TEAM…";
    } else if (remote) {
      wait = ready >= total ? "Ready" : `${ready}/${total} ready`;
    }
    if (btn) {
      btn.textContent = label;
      btn.classList.toggle("ready-on", !!this.bossIntroReadied);
      btn.disabled = remote && this.bossIntroReadied;
    }
    if (hint) hint.textContent = wait;
  }

Game.prototype.syncMusic = function () {
    if (this._readyCheck) {
      if (this._inMatchQueue) Sound.startMenuMusic();
      return;
    }
    if (this.state === "playing" || (this.spectating && this.state === "countdown")) {
      if (this._combatMusicTrack) Sound.startCombatMusic(this._combatMusicTrack);
    } else if (this.state === "countdown") {
      // Stop scoreboard/intermission music but keep _combatMusicTrack for when playing starts.
      Sound.stopCombatMusic();
    } else if (this.state === "shop" || this.state === "roundover") {
      this._combatMusicTrack = null;
      Sound.startIntermissionMusic(this.roundNumber);
    } else if (this._inMatchQueue) {
      this._combatMusicTrack = null;
      Sound.startMenuMusic();
    } else if (this.state === "lobby" || this.state === "menu" || this.state === "matchover") {
      this._combatMusicTrack = null;
      Sound.startMenuMusic();
    } else {
      Sound.stopCombatMusic();
    }
  }

Game.prototype.onState = function (msg) {
    const recv = performance.now();
    // buffer snapshot for interpolation
    const snap = { recv, seq: msg.seq || 0, pr: msg.pr, p: {}, dc: {}, pj: {}, mn: msg.mn || [], sg: msg.sg || [], hp: msg.hp || [], bz: msg.bz || [], fw: msg.fw || [], iw: msg.iw || [], vg: msg.vg || [], hr: msg.hr || [], sm: msg.sm || [], pa: msg.pa || [], nse: msg.nse || [], bb: msg.bb || [], pp: msg.pp || [], ip: msg.ip || [], wf: msg.wf || [], fs: msg.fs || [], ew: msg.ew || [], ec: msg.ec || null };
    for (const w of (msg.p || [])) snap.p[w.id] = w;
    for (const w of (msg.dc || [])) snap.dc[w.id] = w;
    for (const w of (msg.pj || [])) snap.pj[w.id] = w;
    this.snaps.push(snap);
    while (this.snaps.length > 40) this.snaps.shift();
    if (msg.ph === "playing") onSnapshotArrival(this, recv, msg.seq);
    const hidden = this._tabHidden;
    // Frame-health: record snapshot arrival timing (interpolation gap) while playing.
    if (!hidden && this.frameHealth && msg.ph === "playing") {
      this.frameHealth.snapshot(snap.recv, msg.p ? msg.p.length : 0);
    }

    // immediate (non-interpolated) bits
    // Shop/reveal/draft UI is message-driven; stale roundover/playing snapshots
    // (in flight when the shop opens, or during reconnect grace) must not rewind
    // client phase and hide the overlay.
    const shopUiOpen = this.state === "shop" || this.sandboxDraftOpen;
    if (!(shopUiOpen && (msg.ph === "roundover" || msg.ph === "playing"))) {
      this.state = msg.ph;
    }
    this.roundTime = msg.time || 0;
    if (!hidden) {
      if (msg.ph === "bossintro") {
        this.hide("banner");
        if (this.bossIntro && document.getElementById("bossIntro")) this.show("bossIntro");
        else this.hide("bossIntro");
      } else if (msg.ph === "countdown" && this.matchMode !== "sandbox") {
        this.hide("bossIntro");
        const n = Math.ceil(msg.tm);
        this.banner(n > 0 ? String(n) : "FIGHT!");
        this.countdownBeep(n);
      } else if (msg.ph === "playing") {
        if (!this.bossIntroPreview) this.hide("bossIntro");
        this.hide("banner");
      }
      this.syncMusic();
    }
    const wasBt = this._bulletTimeActive;
    const wasOwner = this._bulletTimeOwner;
    const btActive = !!msg.bt;
    // Go omitempty used to drop bto when owner id is 0; treat missing bto as 0 while bt is on.
    const btOwnerId = btActive ? (msg.bto != null ? msg.bto : 0) : null;
    const amOwner = btActive && btOwnerId === this.myId;
    if (!hidden) {
      if (btActive && !wasBt) Sound.bulletTimeStart(amOwner);
      if (wasBt && !btActive) {
        Sound.bulletTimeEnd(wasOwner);
        this.beginBulletTimeTrailCatchUp(this._bulletTimeOwnerId);
      }
      Sound.updateBulletTime(btActive, amOwner);
    }
    this._bulletTimeActive = btActive;
    this._bulletTimeOwner = amOwner;
    this._bulletTimeOwnerId = btOwnerId;
    if (!hidden) {
      if (this.matchMode === "sandbox") {
        this.show("sandboxHud");
        this.updateSandboxShopBtn();
        this.updateSpellSpriteDevPanel();
      } else {
        this.hide("sandboxHud");
        this.closeSandboxShop();
        this.updateSpellSpriteDevPanel();
      }
    }
    const h = this.human();
    if (h && msg.you) {
      h.gold = msg.you.gold;
      if (msg.you.sp != null) h.skillPoints = msg.you.sp;
      if (msg.you.pp != null) h.passivePoints = msg.you.pp;
      if (msg.you.sy != null) h.synergyPoints = msg.you.sy;
      if (msg.you.cd) h.cd = msg.you.cd;
      if (msg.you.ncd !== undefined) this.sandboxNoCD = !!msg.you.ncd;
      if (msg.you.sta !== undefined) this.sandboxStationary = !!msg.you.sta;
      this.syncSandboxCfgUI();
      if (this.sandboxNoCD && h.cd) {
        for (const id of Object.keys(h.cd)) h.cd[id] = 0;
      }
      h.dmgDealt = msg.you.dmg || 0;   // live damage meter
      h.kills = msg.you.kills || 0;
      this._myEffects = (msg.you.fx || []).map(e => ({
        id: e.id,
        buff: !!e.bf,
        spell: e.sp || "",
        rem: e.rem,
        val: e.v || 0,
        at: performance.now(),
      }));
    }
    if (this.inSpectateView() && msg.watch) this.applyWatchKit(msg.watch);
    this.tickRoundSpectate();
    // reconcile the predicted own-position against the server's authoritative one
    const self = (msg.p || []).find(w => w.id === this.myId);
    if (self && !this.roundSpectate) {
      const you = msg.you || {};
      const pr = this.pred;
      pr.init = true;
      pr.alive = self.al; pr.falling = self.fl;
      pr.knockT = you.kn || 0;
      if (h) h.knockT = you.kn || 0;
      const reconcile = {
        x: self.x, y: self.y, vx: you.vx || 0, vy: you.vy || 0,
        alive: self.al, falling: self.fl,
        stun: !!you.st, knockT: you.kn || 0,
        root: !!self.rt, freeze: !!self.fz, channel: (self.cp || 0) > 0,
        rush: !!self.ru, invis: !!self.iv, slow: !!self.sl,
        slowMul: (h && h.slowMul) || 1, moveMult: (h && h.moveMult) || 1,
        mindLash: self.ml || 0, mindCtrl: self.mc || 0,
        face: self.a, aim: self.am != null ? self.am : self.a,
        pending: self.pw || "", channelSpell: self.cs || "",
      };
      this._lastReconcile = reconcile;
      if (this.simReady) {
        if (hidden) this._needReconcile = true;
        else wsimReconcile(reconcile);
      }
    }
    if (!hidden) {
      for (const f of (msg.fx || [])) this.playFX(f);
    }
  }

Game.prototype.applyWins = function (wins) {
    if (!wins) return;
    for (const p of this.players) if (wins[p.id] !== undefined) p.wins = wins[p.id];
  }

Game.prototype.applyPlacements = function (pl) {
    if (!pl) return;
    for (const p of this.players) if (pl[p.id] !== undefined) p.lastPlacement = pl[p.id];
  }

Game.prototype.applyKit = function (msg) {
    const h = this.human();
    if (!h) return;
    if (msg.gold != null) h.gold = msg.gold;
    if (msg.sp != null) h.skillPoints = msg.sp;
    if (msg.pp != null) h.passivePoints = msg.pp;
    if (msg.sy != null) h.synergyPoints = msg.sy;
    if (msg.passives) h.passives = msg.passives;
    if (msg.loadout) h.loadout = msg.loadout;
    if (msg.committed) h.committed = msg.committed;
    if (msg.items) { h.items = msg.items; recalcItems(h); }
  }

Game.prototype.renderSandboxActivity = function (act) {
    const el = document.getElementById("sandboxActivityBody");
    if (!el) return;
    if (!act || (!act.hits && !act.blocked)) {
      el.innerHTML = '<div class="sa-muted">No hits yet — stats clear after 10s without a hit</div>';
      return;
    }
    const secs = (act.secs || 0).toFixed(1);
    let html =
      `<div class="sh-row"><b>Hits</b> ${act.hits}${act.blocked ? ` <span class="sa-muted">(${act.blocked} blocked)</span>` : ""}</div>` +
      `<div class="sh-row"><b>Damage</b> ${Math.round(act.dmg || 0)}</div>` +
      `<div class="sh-row"><b>Knockback</b> ${Math.round(act.knock || 0)} total impulse</div>` +
      `<div class="sh-row"><b>Stun</b> ${(act.stun || 0).toFixed(2)}s total</div>` +
      `<div class="sh-row"><b>DPS</b> ${Math.round(act.dps || 0)} <span class="sa-muted">over ${secs}s</span></div>`;
    const by = act.bySpell || {};
    const spells = Object.keys(by).sort((a, b) => (by[b].dmg || 0) - (by[a].dmg || 0));
    for (const id of spells) {
      const sp = by[id];
      const s = SPELLS[id];
      const label = s ? spellLabelHTML(id) : escapeHtml(id);
      html +=
        `<div class="sa-spell"><b>${label}</b> — ` +
        `${sp.hits || 0} hit${sp.hits === 1 ? "" : "s"}, ` +
        `${Math.round(sp.dmg || 0)} dmg, ` +
        `${Math.round(sp.knock || 0)} knock, ` +
        `${(sp.stun || 0).toFixed(2)}s stun, ` +
        `<b>${Math.round(sp.dps || 0)} DPS</b></div>`;
    }
    el.innerHTML = html;
  }

Game.prototype.tickSandboxActivityIdle = function () {
    if (this.matchMode !== "sandbox") return;
    if (this.state !== "playing" && this.state !== "countdown") return;
    if (this.sandboxShopOpen) return; // shop pause should not eat the 10s idle window
    if (!this.sandboxLastHitAt || !this.sandboxActivity) return;
    if (performance.now() - this.sandboxLastHitAt < 10000) return;
    this.sandboxLastHitAt = 0;
    this.sandboxActivity = null;
    this.renderSandboxActivity(null);
  }

Game.prototype.onSandboxHit = function (msg) {
    this.sandboxLastHitAt = performance.now();
    if (msg.activity) {
      this.sandboxActivity = msg.activity;
      this.renderSandboxActivity(msg.activity);
    }

    const el = document.getElementById("sandboxHitBody");
    if (!el) return;
    if (msg.blocked) {
      el.innerHTML = `<div class="sh-spell">${escapeHtml(spellLabel(msg.spell))}</div><div class="sh-blocked">Blocked (Reflect Shield)</div>`;
      return;
    }
    const s = msg.spell && SPELLS[msg.spell];
    const spellLine = s
      ? `<div class="sh-spell">${spellLabelHTML(msg.spell, null, "sh-spell-ic")}</div>`
      : `<div class="sh-spell">${escapeHtml(spellLabel(msg.spell))}</div>`;
    const rows = [
      `<div class="sh-row"><b>Damage</b> ${Math.round(msg.dmg || 0)}${msg.dealt != null && Math.round(msg.dealt) !== Math.round(msg.dmg || 0) ? ` (${Math.round(msg.dealt)} dealt)` : ""}</div>`,
      `<div class="sh-row"><b>Knockback</b> ${Math.round(msg.knock || 0)} impulse</div>`,
      `<div class="sh-row"><b>Stun</b> ${(msg.stun || 0).toFixed(2)}s</div>`,
      `<div class="sh-row"><b>Target HP</b> ${Math.round((msg.hp || 0) * 100)}% · mass ${Math.round(msg.mass || 0)} (×${(msg.massF || 1).toFixed(2)})</div>`,
      `<div class="sh-row"><b>Low-HP knock</b> ×${(msg.lowHp || 1).toFixed(2)}${msg.stacked ? " · <b>stacked</b>" : ""}${msg.pull ? " · pull" : ""}</div>`,
    ];
    el.innerHTML = spellLine + rows.join("");
    this.sandboxHitFlash = performance.now();
  }

Game.prototype.toggleSandboxShop = function () {
    if (this.matchMode !== "sandbox" || this.state !== "playing" || !this.net) return;
    if (this.sandboxDraftOpen) return;
    if (this.sandboxShopOpen) this.closeSandboxShop();
    else this.net.send({ t: "shopopen", on: true });
  }

Game.prototype.openSandboxDraftRound = function () {
    if (this.matchMode !== "sandbox" || this.state !== "playing" || !this.net) return;
    if (this.sandboxDraftOpen) return;
    if (this.sandboxShopOpen) this.closeSandboxShop();
    this.net.send({ t: "sandboxdraft" });
  }

Game.prototype.closeSandboxDraft = function () {
    this.sandboxDraftOpen = false;
    this.hide("draft");
    Tip.hide();
    SpellPreview.hide();
    this.updateSandboxCfgUI();
  }

Game.prototype.openSandboxDraft = function (msg) {
    this.shopReport = msg.report || null;
    const h = this.human();
    if (h) {
      if (msg.loadout) h.loadout = msg.loadout;
      if (msg.passives) h.passives = msg.passives;
      if (msg.committed) h.committed = msg.committed;
    }
    this.shopDeadline = performance.now() + (msg.secs || 60) * 1000;
    this.shopTotal = msg.total || 1;
    if (msg.kind === "done") {
      this._draftPickAnim = null;
      this.renderDraft(msg);
      this.sandboxDraftOpen = true;
      this.hideAllPanels();
      this.show("draft");
      this.layoutDraftOverlay();
      setTimeout(() => this.closeSandboxDraft(), 500);
      return;
    }
    this.shopReadied = false;
    this.shopReadyCount = 0;
    window.SpellPreview?.hide?.();
    this.renderDraft(msg);
    this.sandboxDraftOpen = true;
    this.hideAllPanels();
    this.show("draft");
    this.layoutDraftOverlay();
    this.updateSandboxCfgUI();
    Sound.ui();
  }

Game.prototype.closeSandboxShop = function () {
    if (this.net && this.matchMode === "sandbox" && this.state === "playing") {
      this.net.send({ t: "shopopen", on: false });
    }
    this.sandboxShopOpen = false;
    const shop = document.getElementById("shop");
    const overlay = document.getElementById("overlay");
    if (shop) shop.classList.remove("shop-in-match");
    if (overlay) overlay.classList.remove("sandbox-shop-open");
    this.hide("shop");
    Tip.hide();
    window.SpellPreview?.hide?.();
    this.updateSandboxShopBtn();
  }

Game.prototype.ensureShopDom = function () {
    if (document.getElementById("shopRound") && document.getElementById("shopGold") && document.getElementById("shopSp")) return;
    const shop = document.getElementById("shop");
    const sub = shop?.querySelector(".shop-sub");
    const tabs = shop?.querySelector(".shop-tabs");
    if (!sub || !tabs) return;
    sub.innerHTML =
      '<span class="shop-sub-status">' +
      '<span id="shopSubLead">Round </span><span id="shopRound">1</span><span id="shopSubTail"> complete — </span>' +
      '</span>';
    let bar = shop.querySelector(".shop-wallets-bar");
    if (!bar) {
      bar = document.createElement("div");
      bar.className = "shop-wallets-bar";
      tabs.insertAdjacentElement("afterend", bar);
    }
    bar.innerHTML =
      '<span class="shop-wallets-lead">Points to spend</span>' +
      '<span class="shop-wallets">' +
      '<span class="shop-wallet sp" title="Skill points">' +
      '<span class="shop-wallet-icon shop-wallet-icon-sp" aria-hidden="true"></span>' +
      '<span class="shop-wallet-label">Skill</span><b id="shopSp">0</b></span>' +
      '<span class="shop-wallet pp" title="Passive points">' +
      '<span class="shop-wallet-icon shop-wallet-icon-pp" aria-hidden="true"></span>' +
      '<span class="shop-wallet-label">Passive</span><b id="shopPp">0</b></span>' +
      '<span class="shop-wallet sy" title="Synergy points">' +
      '<span class="shop-wallet-icon shop-wallet-icon-sy" aria-hidden="true"></span>' +
      '<span class="shop-wallet-label">Synergy</span><b id="shopSy">0</b></span>' +
      '<span class="shop-wallet gold" title="Gold">' +
      '<span class="shop-wallet-gold-label">Gold</span><b id="shopGold">0</b></span>' +
      '</span>';
  }

Game.prototype.openSandboxShop = function (msg) {
    this.applyKit(msg);
    this.ensureShopDom();
    const data = {
      round: msg.round, gold: msg.gold, sp: msg.sp, pp: msg.pp, sy: msg.sy,
      passives: msg.passives || {},
      loadout: msg.loadout || {}, committed: msg.committed || {},
      items: msg.items || {},
    };
    this.renderShopUI(data, (kind, id) => { if (this.net) this.net.send({ t: "buy", kind, id }); Sound.ui(); });
    const shop = document.getElementById("shop");
    const overlay = document.getElementById("overlay");
    if (shop) shop.classList.add("shop-in-match");
    if (overlay) overlay.classList.add("sandbox-shop-open");
    this.sandboxShopOpen = true;
    this.show("shop");
    this.updateSandboxShopBtn();
  }

Game.prototype.onShop = function (msg) {
    if (this.spectating || msg.watch) {
      this.onSpectatorShop({ round: msg.round, secs: msg.secs });
      return;
    }
    this.clearMatchmakerOnMatchStart();
    if (this.matchMode === "sandbox" && this.state === "playing") {
      this.openSandboxShop(msg);
      return;
    }
    if (msg.mode) this.matchMode = msg.mode;
    else if (this.lobbyMode === "pve") this.matchMode = "pve";
    const wasShop = this.state === "shop";
    this.state = "shop";
    this.snaps = [];
    this._interpSnapRecv = 0;
    // PvE: preload the upcoming boss's art now (msg.round is the just-finished round, so
    // PVE_GAUNTLET[msg.round] is next; prep shop has round 0 → first boss). Gives the whole
    // shop + briefing to load before the boss is ever drawn — no temp fallback sprite.
    if (this.matchMode === "pve") ensureBossAssets(PVE_GAUNTLET[msg.round]);
    this.syncMusic();
    this.shopReport = msg.report || null;
    this.applyKit(msg);
    this.hide("banner");
    this.setShopDeadlineFromSecs(msg.secs);
    this.shopReadied = !!msg.shopLocked;
    if (!wasShop) this.shopReadyCount = 0;
    this.shopTotal = msg.total || 1;
    this.updateReadyButton();
    const data = {
      round: msg.round, gold: msg.gold, sp: msg.sp, pp: msg.pp, sy: msg.sy,
      passives: msg.passives || {}, loadout: msg.loadout || {}, committed: msg.committed || {},
      items: msg.items || {},
      planning: msg.planning, shopLocked: msg.shopLocked,
      planSpells: msg.planSpells, planPassives: msg.planPassives,
      previewLoadout: msg.previewLoadout, previewCommitted: msg.previewCommitted,
      previewPassives: msg.previewPassives,
      spAvail: msg.spAvail, ppAvail: msg.ppAvail, syAvail: msg.syAvail,
    };
    const onBuy = (kind, id) => {
      if (this.net) {
        const shop = this._shopData;
        if (shop?.planning && !shop.shopLocked && (kind === "spell" || kind === "passive")) {
          this.applyShopPlanClick(kind, id);
          this.net.send({ t: "shopplan", kind, id });
        } else {
          this.net.send({ t: "buy", kind, id });
        }
      }
      Sound.ui();
    };
    const shopEl = document.getElementById("shop");
    const shopHidden = !shopEl || shopEl.classList.contains("hidden");
    const shopItemsEmpty = !document.getElementById("shopItems")?.querySelector(".spell-card");
    const shopGridEmpty = !document.getElementById("shopGrid")?.querySelector(".category-block");
    const needsFullShop = shopHidden || shopItemsEmpty || shopGridEmpty;
    if (wasShop && msg.planning && !msg.shopLocked && !needsFullShop) {
      this._shopData = data;
      this._shopOnBuy = onBuy;
      this.patchShopPlanUI();
      return;
    }
    this._shopData = data;
    this._shopOnBuy = onBuy;
    if (!wasShop || shopHidden) this.hideAllPanels();
    this.renderShopUI(data, onBuy);
    if (!wasShop || shopHidden) {
      this.show("shop");
      this.updateQuitButton();
    }
  }

Game.prototype.onReveal = function (msg) {
    this.clearMatchmakerOnMatchStart();
    this.state = "shop";
    this.snaps = [];
    this._interpSnapRecv = 0;
    this.syncMusic();
    this.matchMode = "allrandom";
    this.shopReport = msg.report || null;
    const h = this.human();
    if (h) {
      if (msg.loadout) h.loadout = msg.loadout;
      if (msg.passives) h.passives = msg.passives;
      if (msg.items) { h.items = msg.items; recalcItems(h); }
    }
    this.shopDeadline = performance.now() + (msg.secs || 12) * 1000;
    this.shopReadied = false;
    this.shopReadyCount = 0;
    this.shopTotal = msg.total || 1;
    this.updateReadyButton();
    this.renderReveal(msg);
    this.hideAllPanels();
    this.show("reveal");
    Sound.ui();
  }

Game.prototype.renderReveal = function (msg) {
    document.getElementById("revealRound").textContent = msg.round;

    const cards = document.getElementById("revealCards");
    cards.innerHTML = "";
    (msg.grants || []).forEach((g, i) => cards.appendChild(this.revealCard(g, i)));

    const lo = document.getElementById("revealLoadout");
    lo.innerHTML = "";
    const loadout = msg.loadout || {};
    SLOT_ORDER.forEach(slot => {
      const id = loadout[slot];
      if (!id) return;
      const s = SPELLS[id];
      const chip = document.createElement("div");
      chip.className = "reveal-kit-chip";
      chip.setAttribute("data-tip-kind", "spell");
      chip.setAttribute("data-tip-id", id);
      chip.setAttribute("data-tip-lvl", "1");
      chip.innerHTML = `<span class="kit-key">${escapeHtml(keyLabelForSlot(slot))}</span>` +
        `<span class="kit-icon" style="background:${s.color}33;border:1px solid ${s.color}">${spellIconInner(id)}</span>` +
        `<span class="kit-name">${escapeHtml(s.name)}</span>`;
      lo.appendChild(chip);
    });
    const items = msg.items || {};
    ITEM_ORDER.filter(id => (items[id] || 0) > 0).forEach(id => {
      const it = ITEMS[id], n = items[id];
      const chip = document.createElement("div");
      chip.className = "reveal-kit-chip item";
      chip.setAttribute("data-tip-kind", "item");
      chip.setAttribute("data-tip-id", id);
      chip.setAttribute("data-tip-count", String(n));
      chip.innerHTML = `<span class="kit-icon" style="background:rgba(138,134,166,0.2);border:1px solid #8a86a6">${it.icon}</span>` +
        `<span class="kit-name">${escapeHtml(it.name)}${n > 1 ? ` ×${n}` : ""}</span>`;
      lo.appendChild(chip);
    });
  }

Game.prototype.revealCard = function (g, i) {
    const card = document.createElement("div");
    card.className = "reveal-card " + g.kind;
    card.style.animationDelay = `${i * 0.1}s`;
    let icon = "", title = "", sub = "", color = "#8a86a6";
    if (g.kind === "spell") {
      const s = SPELLS[g.id]; color = s.color; icon = spellIconInner(g.id); title = s.name; sub = g.slot ? `New skill · ${keyLabelForSlot(g.slot)}` : "New skill";
      card.setAttribute("data-tip-kind", "spell"); card.setAttribute("data-tip-id", g.id);
    } else if (g.kind === "passive" || g.kind === "synergy") {
      const spellId = g.spellId || g.spellID;
      const host = SPELLS[spellId];
      const n = (PASSIVE_TREES[spellId] || []).find(p => p.id === g.id);
      color = host?.color || "#a855f7";
      icon = g.kind === "synergy" ? synergyIconInner(g.id, n?.name) : spellIconInner(spellId);
      title = n?.name || g.id;
      sub = g.kind === "synergy" ? `Synergy · ${host?.name || spellId}` : `Passive · ${host?.name || spellId}`;
      card.setAttribute("data-tip-kind", "passive");
      card.setAttribute("data-tip-spell", spellId);
      card.setAttribute("data-tip-id", g.id);
    } else {
      const it = ITEMS[g.id]; icon = it.icon; title = it.name; sub = g.lv > 1 ? `Item · ×${g.lv}` : "New item";
      card.setAttribute("data-tip-kind", "item"); card.setAttribute("data-tip-id", g.id); card.setAttribute("data-tip-count", String(g.lv || 1));
    }
    card.innerHTML = `<div class="reveal-card-icon" style="background:${color}22;border:1px solid ${color}">${icon}</div>` +
      `<div class="reveal-card-title">${escapeHtml(title)}</div><div class="reveal-card-sub">${escapeHtml(sub)}</div>`;
    return card;
  }

Game.prototype.updateReadyButton = function () {
    const remote = this.mode === "remote";
    const ready = this.shopReadyCount || 0, total = this.shopTotal || 1;
    const classicShop = this.matchMode === "normal";
    let shopLabel = classicShop ? "Ready & Lock in selections" : "READY — NEXT ROUND";
    let revealLabel = "READY — NEXT ROUND";
    let wait = "", readied = false;
    if (this._drainPaused) {
      // Deploy drain: the shop is frozen server-side and won't start the next
      // round. Show a clear pause instead of a ready prompt; the match resumes
      // automatically after the server restarts and clients reconnect.
      const w = "⏳ Server updating — the match resumes automatically in a moment…";
      for (const wId of ["shopWait", "revealWait", "draftWait"]) {
        const el = document.getElementById(wId);
        if (el) el.textContent = w;
      }
      for (const bId of ["readyBtn", "revealReadyBtn"]) {
        const btn = document.getElementById(bId);
        if (btn) { btn.textContent = "UPDATING…"; btn.classList.remove("readied"); }
      }
      return;
    }
    if (remote && this.shopReadied) {
      const readiedLabel = "✓ READY — CLICK TO CANCEL";
      shopLabel = readiedLabel;
      revealLabel = readiedLabel;
      readied = true;
      wait = `Waiting for others… ${ready}/${total} ready`;
    } else if (remote) {
      wait = `${ready}/${total} players ready`;
    }
    // Drive shop and reveal ready widgets (Skill Draft auto-readies).
    for (const [bId, wId, label] of [
      ["readyBtn", "shopWait", shopLabel],
      ["revealReadyBtn", "revealWait", revealLabel],
    ]) {
      const btn = document.getElementById(bId), w = document.getElementById(wId);
      if (btn) { btn.textContent = label; btn.classList.toggle("readied", remote && readied); }
      if (w) w.textContent = wait;
    }
    const draftWait = document.getElementById("draftWait");
    if (draftWait && (this.matchMode === "skilldraft" || this.matchMode === "pve")) {
      draftWait.textContent = wait || (readied ? "Waiting for others…" : "");
    }
  }

Game.prototype.onMatchOver = function (msg) {
    this.state = "matchover";
    this.clearCreds();
    this.hideSpectateHud();
    this.syncMusic();
    this.hide("banner");
    track("match_over", { mode: "online", won: !!msg.youWin, spectate: this.spectating });
    if (!this.spectating) {
      if (msg.youWin) Sound.playRoundAward();
      else Sound.lose();
    }
    const t = document.getElementById("moTitle");
    const x = document.getElementById("moText");
    if (t) {
      if (this.spectating) t.textContent = "MATCH OVER";
      else if (this.matchMode === "pve") t.textContent = (msg.oc === "win" ? "VICTORY" : "DEFEAT");
      else t.textContent = msg.youWin ? "VICTORY" : "DEFEAT";
    }
    const myName = (this.human() && this.human().name);
    let marked = false;
    const rows = (msg.standings || []).map(s => {
      const you = !marked && s.name === myName; if (you) marked = true;
      return {
        name: s.name, title: s.title || "", titlePos: s.titlePos || 0, admin: !!s.admin,
        wins: s.wins, dmg: s.dmg || 0, kills: s.kills || 0, leaver: !!s.lv, you,
      };
    });
    let html = this.matchStatsHTML(rows, msg.yourDmg);
    if (msg.report) html += `<div class="mo-report">${this.combatReportHTML(msg.report, "match", false, true)}</div>`;
    if (x) x.innerHTML = html;
    const backBtn = document.getElementById("rematchBtn");
    if (backBtn) {
      if (this._fromMatchmaking) backBtn.textContent = "← Back to matchmaking";
      else if (this._fromPractice) backBtn.textContent = "← Back to practice";
      else backBtn.textContent = "← Back to menu";
    }
    // Lobby rematch only — not for matchmaker games, spectators, or offline.
    const rb = document.getElementById("onlineRematchBtn");
    const hint = document.getElementById("rematchHint");
    const lobbyRematch = this.mode === "remote" && !this._fromMatchmaking;
    if (rb && hint) {
      if (!lobbyRematch || this.spectating) {
        rb.classList.add("hidden");
        hint.textContent = this.spectating ? "You watched as a spectator." : "";
        hint.classList.toggle("hidden", !this.spectating);
      } else if (this.isHost) {
        rb.classList.remove("hidden");
        hint.classList.remove("hidden");
        hint.textContent = "Start a rematch to send everyone back to the lobby.";
      } else {
        rb.classList.add("hidden");
        hint.classList.remove("hidden");
        hint.textContent = "Waiting for the host to start a rematch…";
      }
    }
    this.show("matchover");
  }
